/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import Chart from 'chart.js/auto'
import {CategoryScale} from 'chart.js'
import JumlahKoleksiBukuPie from '../PieChart/JumlahKoleksiBukuPie'
import {KOLEKSITERBANYAK} from '../../../../api'
import {executePost} from '../../../../configs/Kubuku'

type Props = {
  className: string
  title?: string
  title2?: string
}

Chart.register(CategoryScale)

const MixedWidget8: React.FC<Props> = ({
  className,
  title = '10 PERPUSTAKAAN TERATAS',
  title2 = 'BERDASARKAN JUMLAH KOLEKSI BUKU',
}: Props) => {
  const [koleksiTerbanyak, setKoleksiTerbanyak] = useState<
    {
      nama: string
      total_koleksi: string
    }[]
  >([])

  const [chartData, setChartData] = useState({
    labels: [] as string[],
    datasets: [
      {
        label: 'User Gained',
        data: [] as string[],
        backgroundColor: [
          'rgba(75, 192, 192, 1)',
          '#ecf0f1',
          '#50AF95',
          '#f3ba2f',
          '#2a71d0',
          '#A52A2A',
          '#00FFFF',
          '#FF7F50',
          '#FFE4C4',
          '#8A2BE2',
        ],
        borderColor: 'black',
        borderWidth: 2,
      },
    ],
  })

  useEffect(() => {
    const GetDataKoleksiTerbanyak = async () => {
      const formData = new FormData()
      const response = await executePost(KOLEKSITERBANYAK, formData)
      const data = response?.data
      setKoleksiTerbanyak(data)
    }

    GetDataKoleksiTerbanyak()
  }, [])

  useEffect(() => {
    const labels = koleksiTerbanyak.map((data) => data.nama)
    const dataValues = koleksiTerbanyak.map((data) => data.total_koleksi)

    setChartData((prevChartData) => ({
      ...prevChartData,
      datasets: [
        {
          ...prevChartData.datasets[0],
          data: dataValues,
        },
      ],
      labels: labels,
    }))
  }, [koleksiTerbanyak])

  return (
    <div className={`card ${className}`}>
      {/* begin::Beader */}
      <div className='card-body d-flex flex-column justify-content-between'>
        <h2 className='text-dark fw-bold mb-5 text-center'>
          {title} <br /> {title2}{' '}
        </h2>

        <div className='m-0'>
          <JumlahKoleksiBukuPie chartData={chartData} />
        </div>
      </div>
    </div>
  )
}

export {MixedWidget8}
